
const oldModels = require('./oldFormModel.js');
const compensation = require('./compensationModel.js');
const customValid = require('./customValidation.js');
const categories = require('./categories.js');
require('ko-component-fio-input');
require('ko-component-file-upload');
require('ko-component-file-upload2');

const _ = require('lodash');
import ko from 'rgs-knockout';
import kv from 'rgs-knockout-validation';
const Serializable = require('serializable');
const EventEmitter = require('events');

function and () {
	return _.uniq([].concat.apply([], arguments));
}

function FilesObservableArray () {
	const self = _.extend(ko.observableArray(), {
		toJS: function () {
			return _.map(_.filter(self(), function (f) {
				return f.State() === 'uploaded';
			}), function (f) {
				return f.toJS();
			});
		},
	});
	return self;
}

function individual () {
	const self = Serializable({
		HasNoPreviousLicense: ko.observable(false),

		FirstName: ko.observable().extend({
			validation: customValid.cyrrilicOnly,
		}),
		LastName: ko.observable().extend({
			validation: customValid.cyrrilicOnly,
		}),
		MiddleName: ko.observable().extend({
			validation: customValid.cyrrilicOnly,
		}),

		PassportSeries: ko.observable(),
		PassportNumber: ko.observable(),

		SameAsContactInfo: ko.observable(),
		SameAsPreviousPolicy: ko.observable(),

		DateIncludeInPolicy: ko.observable().extend({
			pattern: /\d{2}\.\d{2}\.\d{4}/,
			validation: and(customValid.date,
					_.extend({}, customValid.dateAfter, { params: '01.07.2003' }),
					_.extend({}, customValid.dateBefore, { params: customValid.today() })
			),
		}),

		Birthday: ko.observable().extend({
			pattern: /\d{2}\.\d{2}\.\d{4}/,
			validation: and(customValid.date,
				_.extend({}, customValid.dateAfter, { params: '01.01.1900' }),
				_.extend({}, customValid.dateBefore, { params: customValid.eighteen() })
			),
		}),

		License: ko.observable(),
		PreviousLicense: ko.observable(),

		LicenseFilesObverse: (new FilesObservableArray()).extend({
			validation: customValid.maxFileSize,
		}),
		LicenseFilesReverse: (new FilesObservableArray()).extend({
			validation: customValid.maxFileSize,
		}),
		PreviousLicenseFilesObverse: (new FilesObservableArray()).extend({
			validation: customValid.maxFileSize,
		}),
		PreviousLicenseFilesReverse: (new FilesObservableArray()).extend({
			validation: customValid.maxFileSize,
		}),
	});

	function copyFromOther (other) {
		_.map([
			'FirstName',
			 'LastName',
			 'MiddleName',
		], function (p) {
			self[p](other[p]());
		});
	}
	_.extend(self, _.pick(_.bindAll(new EventEmitter()), 'on', 'emit'));

	self.on('copyFromOther', function (model) {
		if (self.SameAsContactInfo()) {
			copyFromOther(model.ContactInfo);
		} else if (self.SameAsPreviousPolicy()) {
			let myRole = 'dunno'; // 'dunno', 'owner', 'driver'
			let driverIx = -1;
			let policyIx = -1;
			_.each(model.KbmOsago.Policies(), function (p, i) {
				if (p.OwnerIndividual === self) {
					policyIx = i;
					myRole = 'owner';
					return true;
				} else if ((driverIx = p.Drivers.indexOf(self)) >= 0) {
					policyIx = i;
					myRole = 'driver';
					return true;
				} else {
					return false;
				}
			});
			if (policyIx < 0) {
				return;
			}
			const pp = model.KbmOsago.Policies()[policyIx - 1];
			if (!pp) {
				return;
			}
			if (myRole === 'owner') {
				copyFromOther(pp.OwnerIndividual);
			} else if (myRole === 'driver') {
				copyFromOther(pp.Drivers()[driverIx]);
			}
		}
	});

	self.constructor = individual;

	return self;
}

function DriverIndividual () {
	const self = new individual();

	self.License.extend({
		pattern: /\d{2} \S{2} \d{6}/,
	});

	self.PreviousLicense.extend({
		pattern: /\d{2} \S{2} \d{6}/,
	});

	return self;
}

function OwnerIndividual () {
	const self = new individual();

	self.PassportSeries.extend({
		pattern: /\d{2} \d{2}/,
		validation: {
			validator: function (v) {
				return !v || /^\d{4}$/.test((String(v)).replace(/\s+/g, ''));
			},
			message: 'введите 4 цифры',
		},
	});

	self.PassportNumber.extend({
		digit: true,
		validation: {
			validator: function (v) {
				return !v || /^\d{6}$/.test(v);
			},
			message: 'введите 6 цифр',
		},
	});

	return self;
}

function LegalEntity () {
	const self = Serializable({
		SameAsContactInfo: ko.observable(),
		SameAsPreviousPolicy: ko.observable(),

		Name: ko.observable(),
		Inn: ko.observable(),
		DateIncludeInPolicy: ko.observable().extend({
			pattern: /\d{2}\.\d{2}\.\d{4}/,
			validation: and(customValid.date,
					_.extend({}, customValid.dateAfter, { params: '01.07.2003' }),
					_.extend({}, customValid.dateBefore, {params: customValid.today()})
			),
		}),
	});

	function copyFromOther (other) {
		_.map([
			'Name',
			// , 'Inn'
		], function (p) {
			self[p](other[p]());
		});
	}

	_.extend(self, _.pick(_.bindAll(new EventEmitter()), 'on', 'emit'));

	self.on('copyFromOther', function (model) {
		if (self.SameAsContactInfo()) {
			self['Name'](model.ContactInfo.CompanyName());
		} else if (self.SameAsPreviousPolicy()) {
			let policyIx = -1;
			_.each(model.KbmOsago.Policies(), function (p, i) {
				if (p.OwnerLegalEntity === self) {
					policyIx = i;
					return true;
				} else {
					return false;
				}
			});
			if (policyIx < 0) {
				return;
			}
			const pp = model.KbmOsago.Policies()[policyIx - 1];
			if (!pp) {
				return;
			}
			copyFromOther(pp.OwnerLegalEntity);
		}
	});

	self.constructor = LegalEntity;

	return self;
}

function Vehicle () {
	const self = Serializable({
		VehicleTypes: ko.observableArray([
			{ name: 'VIN', value: 'Vin' },
			{ name: 'Кузов', value: 'BodyNumber' },
			{ name: 'Шасси', value: 'ChassisNumber' },
		]),
		VehicleType: ko.observable(),
		BodyNumber: ko.observable(),
		ChassisNumber: ko.observable(),
		Vin: ko.observable(),
		RegNumber: ko.observable().extend({
			validation: customValid.regNumber,
		}),
		CertificateFilesObverse: (new FilesObservableArray()).extend({
			validation: customValid.maxFileSize,
		}),
		CertificateFilesReverse: (new FilesObservableArray()).extend({
			validation: customValid.maxFileSize,
		}),

		ObsIdentityVechicle: ko.pureComputed({
			read: function (){
				return self[self.VehicleType()];
			},
			owner: self,
		}),
	});

	self.BodyNumber.extend({
		validation: _.extend( new customValid.consecutiveCharRepetitionLimit(), { params: {
			onlyIf: function () {
				return Boolean(self) && self.VehicleType() === 'BodyNumber';
			},
		}}),
		notEqual: '-',
	});
	self.ChassisNumber.extend({
		validation: _.extend( new customValid.consecutiveCharRepetitionLimit(), { params: {
			onlyIf: function () {
				return Boolean(self) && self.VehicleType() === 'ChassisNumber';
			},
		}}),
		notEqual: '-',
	});
	self.Vin.extend({
		pattern: /[A-z0-9]{17}/,
		validation: _.extend( new customValid.consecutiveCharRepetitionLimit(), { params: {
			onlyIf: function () {
				return Boolean(self) && self.VehicleType() === 'Vin';
			},
		}}),
		notEqual: '-',
	});

	self.constructor = Vehicle;

	return self;
}

function Policy (js) {
	const DRIVERS_MAX = 5;
	const DRIVERS_MIN = 1;

	const self = Serializable({
		IsLatestPolicy: ko.observable(false),

		Series: ko.observable(),

		Number: ko.observable().extend({
			minLength: 10,
			maxLength: 10,
			number: true,
		}),

		Region: ko.observable(),

		Files: (new FilesObservableArray()).extend({
			validation: customValid.maxFileSize,
		}),

		UnlimitedDriversValue: ko.observable(),
		UnlimitedDrivers: ko.pureComputed(function () {
			const val = self.UnlimitedDriversValue();
			return val && val === 'Unlimited';
		}),

		OwnerTypeValue: ko.observable(),
		OwnerIsIndividual: ko.pureComputed(function () {
			return self.OwnerTypeValue() === 'individual';
		}),
		OwnerIsLegalEntity: ko.pureComputed(function () {
			return !self.OwnerIsIndividual();
		}),

		OwnerIndividual: new OwnerIndividual(),
		OwnerLegalEntity: new LegalEntity(),

		Drivers: ko.observableArray([
			new DriverIndividual(),
		]),

		Vehicle: new Vehicle(),
	});

	self.fromJS(js);

	self.constructor = Policy;

	_.extend(self, _.pick(_.bindAll(new EventEmitter()), 'on', 'emit'));
	self.on('AddDriverClick', function () {
		if (self.Drivers().length >= DRIVERS_MAX) {
			return;
		}
		self.Drivers.push(new DriverIndividual());
	});

	self.on('RemoveDriverClick', function (driver) {
		if (self.Drivers().length <= DRIVERS_MIN) {
			return;
		}
		self.Drivers.remove(driver);
	});

	return self;
}

function KbmOsago () {
	const POLICIES_MAX = 5;
	const POLICIES_MIN = 1;

	const self = Serializable({
		Policies: ko.observableArray([
			new Policy({
				IsLatestPolicy: true,
			}),
		]),
	});

	self.constructor = KbmOsago;

	_.extend(self, _.pick(_.bindAll(new EventEmitter()), 'on', 'emit'));
	self.on('AddPolicyClick', function () {
		if (self.Policies().length >= POLICIES_MAX) {
			return;
		}
		self.Policies.push(new Policy());
	});

	self.on('RemovePolicyClick', function () {
		if (self.Policies().length <= POLICIES_MIN) {
			return;
		}
		self.Policies.pop();
	});

	return self;
}

function TrialClaim () {
	const self = Serializable({
		LossID: ko.observable().extend({ required: true }),
		DocNumber: ko.observable(),
		GovNumber: ko.observable(),
		DocSeries: ko.observable(),
	});

	return self;
}

function ComplaintsForm (js) {
	const self = Serializable({
		EmployeeMode: ko.observable(false),
		HomeUrl: ko.observable('/'),
		IsDataProcessed: ko.observable(false).extend({
			equal: {
				params: true,
				message: [
					'подтвердите свое согласие на обработку персональных данных',
					'подтвердите согласие на обработку ПД',
				],
			},
		}),

		ComplaintId: ko.observable(),
		ContactInfo: new oldModels.commonInfomation(),
		Compensation: new compensation(),
		SelectOffice: new oldModels.selectOffice(),
		ClaimSettlement: new oldModels.claimSettlement(),
		TelephoneService: new oldModels.telephoneService(),
		TrialClaim: new TrialClaim(),

		ResponseEmail: ko.observable(),
		ResponseInfo: new oldModels.responseInfo('Response'),
		Categories: new categories(),
		KbmOsago: new KbmOsago(),

		Captcha: Serializable({
			Passed: ko.observable(false),
			Value: ko.map(ko.observable(), {
				mapWrite: v => {
					if (v) {
						self.Captcha.Value.clearError();
					}
					return v;
				},
			})
				.extend({required: {
					params: true,
					onlyIf: function (){
						return !self.EmployeeMode() && self.EmailCheck.Sent();
					},
				}}),
			Key: ko.observable(),
		}),
		EmailCheck: Serializable({
			Value: ko.observable()
				.extend({required: {
					params: true,
					onlyIf: function (){
						return !self.EmployeeMode() && self.EmailCheck.Sent();
					},
				}}),

			SentToEmail: ko.observable(),
			PassedByEmail: ko.observable(),

			Passed: ko.pureComputed(function () {
				return self.ContactInfo.xEmail()
						&& self.ContactInfo.xEmail() === self.EmailCheck.PassedByEmail();
			}),
			Sent: ko.pureComputed(function () {
				return self.ContactInfo.xEmail()
						&& self.ContactInfo.xEmail() === self.EmailCheck.SentToEmail();
			}),
		}),
	});

	self.UploadingFiles = ko.observableArray([]).extend({validation: {
		params: true,
		validator: function (v) {
			return v.length === 0;
		},
	}});

	self.ClaimSettlement.InsuranceProductKind.extend({required: {
		params: true,
		onlyIf: function (){
			return self.Categories.api.visibleSection.isFullClaimStatus();
		},
	}});

	self.ClaimSettlement.AccidentDamageKind.extend({required: {
		params: true,
		onlyIf: function (){
			return self.Categories.api.visibleSection.isFullClaimStatus()
				&& self.ClaimSettlement.InsuranceProductKind() === 'Voluntary';
		},
	}});

	self.ClaimSettlement.PaymentRequestNumber.extend({required: {
		params: true,
		onlyIf: function (){
			return (self.Categories.api.visibleSection.isFullClaimStatus()
					&& (self.ClaimSettlement.AccidentDamageKind() === 'Vehicle'
						|| self.ClaimSettlement.InsuranceProductKind() === 'Compulsory'))
				|| self.Categories.api.visibleSection.isLiteClaimStatus();
		},
	}});
	self.ClaimSettlement.VehicleMaker.extend({required: {
		params: true,
		onlyIf: function (){
			return (self.Categories.api.visibleSection.isFullClaimStatus()
					&& (self.ClaimSettlement.AccidentDamageKind() === 'Vehicle'
						|| self.ClaimSettlement.InsuranceProductKind() === 'Compulsory'))
				|| self.Categories.api.visibleSection.isLiteClaimStatus();
		},
	}});
	self.ClaimSettlement.VehicleModel.extend({required: {
		params: true,
		onlyIf: function (){
			return (self.Categories.api.visibleSection.isFullClaimStatus()
					&& (self.ClaimSettlement.AccidentDamageKind() === 'Vehicle'
						|| self.ClaimSettlement.InsuranceProductKind() === 'Compulsory'))
				|| self.Categories.api.visibleSection.isLiteClaimStatus();
		},
	}});
	self.ClaimSettlement.VehicleRegistrationNumber.extend({required: {
		params: true,
		onlyIf: function (){
			return (self.Categories.api.visibleSection.isFullClaimStatus()
					&& (self.ClaimSettlement.AccidentDamageKind() === 'Vehicle'
						|| self.ClaimSettlement.InsuranceProductKind() === 'Compulsory'))
				|| self.Categories.api.visibleSection.isLiteClaimStatus();
		},
	}});

	self.ValidationGroup = kv.computedGroup(function (){
		const result = [
			self.ContactInfo,
			self.ResponseInfo,
			self.Categories.api.validationCategories(),
			self.Captcha,
			self.EmailCheck,
			self.UploadingFiles,
			self.IsDataProcessed,
			self.TrialClaim,
		];
		if (self.Categories.api.visibleSection.isKbm()
			&& !self.EmployeeMode()
		) {
			result.push(self.KbmOsago);
		}

		if (self.Categories.api.visibleSection.isFullClaimStatus()
			|| self.Categories.api.visibleSection.isLiteClaimStatus()
		) {
			result.push(self.ClaimSettlement);
		}

		if (self.Categories.api.visibleSection.isSelectOffice()) {
			result.push(self.SelectOffice);
		}

		if (self.Categories.api.visibleSection.isPhoneService()) {
			result.push(self.TelephoneService);
		}

		if (self.Categories.api.visibleSection.isCompensation()) {
			result.push(self.Compensation);
		}

		return result;
	});

	self.toJS = function () {
		const js = _.extend(
			self.ContactInfo.toJS(),
			{
				ComplaintId1: self.Categories.api.toJS().Categories[0].ID,
			},
			new oldModels.claimSettlement().toJS(),
			self.Compensation.toJS(),
			self.TelephoneService.toJS(),
			self.ResponseInfo.toJS(),
			self.Categories.api.toJS(),
			{
				ContactInfo: {
					CommentFiles: _.transform(self.ContactInfo.CommentFiles(), function (res, v) {
						res.push(v.toJS());
					}, []),
				},
			}, {
				KbmOsago: self.KbmOsago.toJS(),
			}, {
				TrialClaim: self.TrialClaim.toJS(),
			});

		if (self.Categories.api.visibleSection.isFullClaimStatus()
			|| self.Categories.api.visibleSection.isLiteClaimStatus()
		) {
			_.extend(js, self.ClaimSettlement.toJS());
		}

		if (self.Categories.api.visibleSection.isSelectOffice()) {
			_.extend(js, self.SelectOffice.toJS());
		}

		return js;
	};
	self.WorkingState = ko.oneOf([
		'init',
		'working',
		'checking',
		'sendingCode',
		'submiting',
		'submit',
	]);



	self.isReady = ko.observable(false);

	self.fromJS(js);

	_.extend(self, _.pick(_.bindAll(new EventEmitter()), 'on', 'emit'));

	return self;
}

module.exports = ComplaintsForm;
